import { connect } from 'react-redux';
import { getURL } from '~/server/formatters';
import ProfilesDisconnectedBanner from './components/ProfilesDisconnectedBanner';

export default connect(
  (state) => {
    let displayExtraMessage = false;
    const selectedProfile = state.profileSidebar?.selectedProfile;

    if (
      selectedProfile?.service === 'instagram' &&
      selectedProfile?.service_type === 'profile'
    ) {
      displayExtraMessage = true;
    }

    return {
      profileId: selectedProfile?.id,
      service: selectedProfile?.service,
      displayExtraMessage,
      canReconnectChannels: state.organizations.selected?.canReconnectChannels,
      ownerEmail: state.organizations.selected?.ownerEmail,
    };
  },
  () => ({
    onReconnectProfileClick: () => {
      window.location.assign(getURL.getAccountChannelsURL());
    },
  })
)(ProfilesDisconnectedBanner);
